import { CLIENT_URL } from '@shared/config/api/api';
import { StandardResponseType } from '@shared/types/global';
import { CheckAuthCodeReq } from '@widgets/Auth/model/types/checkAuthCode';

export const checkAuthCode = async (data: CheckAuthCodeReq): Promise<StandardResponseType> => {
  const res = await fetch(`${CLIENT_URL}/v2/auth/otp/verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    },
    body: JSON.stringify(data)
  });

  return await res.json();
};
